var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"xyt-cropper",style:(_vm.wrapperStyle)},[_c('img',{ref:"img",style:(_vm.imgStyle),attrs:{"src":_vm.src}})])}
var staticRenderFns = []

export { render, staticRenderFns }